import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }

  connect () {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': token,
        'Accept': 'text/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(response => response.text())
      .then(script => {
        const el = document.createElement('script')
        el.textContent = script
        document.body.appendChild(el)
        el.remove()
      })
  }
}
